import { isNumericTable, naturalCompare } from './tableSort';

/**
 * Spec 04-ux-mobile-spec.md §"Sorting" — Sur place / Emporter note labels
 * (table numbers `12`/`A1` or Emporter free-text labels `JACK`) order the
 * same way the room already does: pure-numeric labels first (natural, so
 * `2 < 9 < 10`), then lettered/text labels, base-insensitive. Reuses
 * `tableSort.ts`'s comparator rather than re-implementing it.
 */
export function compareNoteLabels(a: string, b: string): number {
  const aNumeric = isNumericTable(a);
  const bNumeric = isNumericTable(b);
  if (aNumeric !== bNumeric) return aNumeric ? -1 : 1;
  return naturalCompare(a, b);
}

/** Non-mutating: returns a new, sorted array. */
export function sortNoteLabels(labels: string[]): string[] {
  return [...labels].sort(compareNoteLabels);
}
